import { render, staticRenderFns } from "./FormFoto.vue?vue&type=template&id=4143de90&scoped=true"
import script from "./FormFoto.vue?vue&type=script&lang=js"
export * from "./FormFoto.vue?vue&type=script&lang=js"
import style0 from "./FormFoto.vue?vue&type=style&index=0&id=4143de90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4143de90",
  null
  
)

export default component.exports